import type { ReactNode } from 'react';
import { cn } from '@shared/utils';

export interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  /** 下一步可以做的事，通常是一顆按鈕 */
  action?: ReactNode;
  className?: string;
}

/** 清單沒有內容時的引導：說明為什麼是空的，以及下一步可以做什麼。 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3.5 px-8 py-14 text-center',
        className,
      )}
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full border border-border bg-card text-muted-foreground">
        {icon}
      </div>
      <p className="font-display text-base text-strong">{title}</p>
      <p className="max-w-[30ch] text-[0.8125rem] leading-relaxed text-muted-foreground">
        {description}
      </p>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
